<template>
  <zkContent
    @contentHeight="contentHeight"
    leftStyle="width:30%"
    rightStyle="width:70%"
  >
    <div slot="left">
      <orgTree @selectNode="selectNode"></orgTree>
    </div>
    <div slot="right">
      <orgInfo :parentDept="parentDept" :currentOrg="currentOrg"></orgInfo>
    </div>
  </zkContent>
</template>

<script>
import orgTree from './orgStructure/orgTree'
import orgInfo from './orgStructure/orgInfo'
export default {
  data() {
    return {
      height: 500,
      currentOrg: {},
      parentDept: null
    }
  },
  mounted() {},
  methods: {
    contentHeight(height) {
      this.height = height
    },
    selectNode(node) {
      if (node) {
        this.currentOrg = node.data
        if (node.parent && node.level > 1) {
          this.parentDept = node.parent.data
        } else {
          this.parentDept = null
        }
      } else {
        this.currentOrg = null
      }
    }
  },
  components: {
    orgTree,
    orgInfo
  }
}
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/orgStructure.vue